import { hsbcCardMap, testCardData } from "@hsbc/utilities";
import { isProductionEnv } from "./constants";

export const testCardPrefixes = isProductionEnv()
  ? [411111, 444433, 555555]
  : [
      411111, 444433, 555555, 222300, 378282, 601111, 305693, 356999, 501971,
      675900, 506228, 506731, 506770, 603522, 589562, 602049, 560718, 506099,
      455676, 2222, 5577, 400,
    ];

export const getCardByBin = (bin: string, disableBinCheck = false) => {
  if (disableBinCheck) return testCardData;
  if (!isValidCardNumber(bin)) return undefined;

  return hsbcCardMap[bin] ?? testCardData;
};

export const isValidCardNumber = (cardNumber: string) => {
  const firstSixDigits = cardNumber.slice(0, 6);

  return (
    hsbcCardMap[firstSixDigits] !== undefined ||
    testCardPrefixes.find((prefix) =>
      cardNumber.startsWith(prefix.toString())
    ) !== undefined
  );
};
